/**
 * The workspace plate at the top of the sidebar.
 *
 * It used to open a menu of quick-create, jump-to and workspace actions, and
 * every one of those had a second, closer home already: the rail below it for
 * jumping, the page header for a new client, the avatar menu for profile,
 * settings, backup, lock and sign-out. A menu that only repeats what is one
 * click away on either side of it is a door to nowhere, so the plate is now
 * what it looks like - a label, not a control. Nothing here can be clicked,
 * which is why it does not render as a button.
 *
 * The second line is the brand mark rather than its name set in type: a logo
 * is a picture of a company, and spelling it out in the interface font is
 * the one place a brand is not allowed to look like everything else. The
 * file is dropped in `public/` and swapped without touching this; if it is
 * not there yet the name is drawn instead, so a missing asset is a plainer
 * sidebar rather than a broken one.
 *
 * The wordmark in the asset is white, which is invisible on a light rail,
 * so it sits on a dark plate. That is how a white-on-transparent logo is
 * meant to be used, and it beats inverting the file - the gradient in the
 * mark would inverse with it and come out the wrong colours.
 */
import { useApp } from '../store/AppContext.jsx';

export default function WorkspaceMenu() {
  const { S } = useApp();
  const name = S.workspace || 'Client Master';
  /* Brand wordmark as a text lockup (redesign): the brand on top in the brand
     colour, the workspace name beneath — no dark logo plate. "XYRA AI" -> the
     first word is the mark. */
  const brand = (S.companyName || 'XYRA AI').trim().split(/\s+/)[0] || 'XYRA';

  return (
    <div className="brandrow" title={`${brand} · ${name}`}>
      <div className="brandlock">
        <b className="brandmark">{brand}</b>
        <span className="brandsub">{name}</span>
      </div>
    </div>
  );
}
